import {Observable} from 'rxjs'
import {TranslateService} from '@ngx-translate/core';
import {Inject, Injectable} from '@angular/core';

@Injectable()
export class TranslateManager {

    constructor(@Inject(TranslateService) public translate: TranslateService) {
    }

    public configure() {
        console.log('VENDOR:' + VENDOR);
        if (VENDOR === 'nexyiu') {
            this.translate.setDefaultLang('it');
            this.translate.use('it');
        } else {
            this.translate.setDefaultLang('en');
            this.translate.use('en');
        }
    };

    public getLocale(): string {
        //todo andrey implement
        return 'en';
    };

    public setLocale(locale: string): void {
        //todo andrey implement
    };

    public getValueAsync(key: string, interpolation?: any): Observable<string | any> {
        return this.translate.get(key, interpolation);
    }

    public getValue(key: string, interpolation?: any): string {
        return this.translate.instant(key, interpolation);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/translate/translate.manager.ts